import { render, staticRenderFns } from "./application-form.vue?vue&type=template&id=20b70ab0&scoped=true"
import script from "./application-form.vue?vue&type=script&lang=js"
export * from "./application-form.vue?vue&type=script&lang=js"
import style0 from "./application-form.vue?vue&type=style&index=0&id=20b70ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b70ab0",
  null
  
)

export default component.exports